import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'
import { useNavigate } from 'react-router-dom'

const employees = [
  { id:'1', name:'Jamie Mitchell',  init:'JM', dept:'Operations',      position:'Operations Coordinator',    status:'active',    hire:'Jan 12, 2023', attendance:96,  score:4.2 },
  { id:'2', name:'Sam Rivera',      init:'SR', dept:'Operations',      position:'Operations Specialist',     status:'active',    hire:'Mar 3, 2022',  attendance:92,  score:3.9 },
  { id:'3', name:'Kim Park',        init:'KP', dept:'Administrative',  position:'Admin Coordinator',         status:'active',    hire:'Jun 7, 2021',  attendance:100, score:4.6 },
  { id:'4', name:'Dana Lee',        init:'DL', dept:'Field Staff',     position:'Field Coordinator',         status:'active',    hire:'Sep 15, 2023', attendance:94,  score:4.1 },
  { id:'5', name:'Marcus Thomas',   init:'MT', dept:'Operations',      position:'Operations Associate',      status:'warning',   hire:'Feb 20, 2022', attendance:78,  score:2.8 },
  { id:'6', name:'Jordan Collins',  init:'JC', dept:'Field Staff',     position:'Field Associate',           status:'active',    hire:'Nov 1, 2023',  attendance:88,  score:3.5 },
  { id:'7', name:'Paula Reyes',     init:'PR', dept:'Customer Service',position:'Customer Service Rep',      status:'active',    hire:'Apr 5, 2022',  attendance:97,  score:4.3 },
  { id:'8', name:'Tyler Walsh',     init:'TW', dept:'Administrative',  position:'Admin Assistant',           status:'onboarding',hire:'Apr 1, 2025',  attendance:null,score:null },
  { id:'9', name:'Lena Fischer',    init:'LF', dept:'Field Staff',     position:'Field Associate',           status:'active',    hire:'Aug 10, 2022', attendance:91,  score:3.8 },
  { id:'10',name:'Marcus Webb',     init:'MW', dept:'Operations',      position:'Operations Associate',      status:'active',    hire:'Jan 20, 2023', attendance:95,  score:4.0 },
  { id:'11',name:'Sofia Reyes',     init:'SR', dept:'Customer Service',position:'Customer Service Lead',     status:'active',    hire:'Mar 12, 2021', attendance:99,  score:4.7 },
  { id:'12',name:'David Kim',       init:'DK', dept:'Field Staff',     position:'Field Coordinator',         status:'active',    hire:'Jun 3, 2023',  attendance:90,  score:3.7 },
]

const onboarding = [
  { id:'o1', name:'Alex Turner',   init:'AT', position:'Operations Associate', dept:'Operations',     progress:75, steps:3, totalSteps:4, startDate:'Apr 15, 2025' },
  { id:'o2', name:'Priya Sharma',  init:'PS', position:'Field Coordinator',    dept:'Field Staff',    progress:50, steps:2, totalSteps:4, startDate:'Apr 22, 2025' },
  { id:'o3', name:'Carlos Mendez', init:'CM', position:'Admin Assistant',      dept:'Administrative', progress:25, steps:1, totalSteps:4, startDate:'May 1, 2025'  },
]

export default function EmployeeRoster() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [filterDept, setFilterDept] = useState('All')
  const [filterStatus, setFilterStatus] = useState('All')
  const [activeView, setActiveView] = useState('active')
  const [showNewEmployee, setShowNewEmployee] = useState(false)
  const [step, setStep] = useState(1)
  const [packetSent, setPacketSent] = useState(false)

  const [newEmp, setNewEmp] = useState({
    firstName:'', lastName:'', email:'', phone:'',
    dept:'Operations', position:'', startDate:'', type:'Full Time'
  })
  const [checklist, setChecklist] = useState({
    offer:false, i9:false, background:false,
    handbook:true, policies:true, training:true, portal:true
  })
  const [itReq, setItReq] = useState({
    standardLaptop:false, standardMac:false, standardWindows:false,
    highEndLaptop:false, highEndMac:false, highEndWindows:false,
    keyboardMouse:true, keyboardMac:false, keyboardWindows:true,
    webcam:false,
    cable:false, cableType:'',
    charger:false, chargerType:'',
    dockingStation:false, dockingMac:false, dockingWindows:false,
    externalStorage:false, usbFlash:false, usbHardDrive:false,
    monitor:true, monitorStandard:true, monitorLarge:false,
    software:false, softwareType:'',
    other:false, otherType:'',
    fundingSource:'HR-ONBOARD-2025', approvedBy:'Tiffany Gallagher',
    assignTo:'John Gallagher',
  })
  const [facReq, setFacReq] = useState({
    mainEntrance:true, deptWing:true, parking:false,
    breakRoom:true, serverRoom:false, execFloor:false,
    other:false, otherNote:'',
    assignTo:'Facilities Team',
  })

  const tog = (setter, field) => setter(s => ({...s, [field]: !s[field]}))

  const depts = ['All','Operations','Administrative','Field Staff','Customer Service']
  const statusColor = s => s==='active'?'#4A7C59':s==='warning'?'#A0392B':s==='onboarding'?'#4A6B8A':'#6B7D6B'
  const statusLabel = s => s==='active'?'Active':s==='warning'?'Warning':s==='onboarding'?'Onboarding':'Inactive'

  const filtered = employees.filter(e => {
    const matchSearch = e.name.toLowerCase().includes(search.toLowerCase()) || e.dept.toLowerCase().includes(search.toLowerCase())
    const matchDept = filterDept === 'All' || e.dept === filterDept
    const matchStatus = filterStatus === 'All' || e.status === filterStatus
    return matchSearch && matchDept && matchStatus
  })

  function buildITItems() {
    const items = []
    if (itReq.standardLaptop) { const os = itReq.standardMac&&itReq.standardWindows?'Mac & Windows':itReq.standardMac?'Mac':itReq.standardWindows?'Windows':''; items.push('Standard Laptop ($499-$899)'+(os?' - '+os:'')) }
    if (itReq.highEndLaptop)  { const os = itReq.highEndMac&&itReq.highEndWindows?'Mac & Windows':itReq.highEndMac?'Mac':itReq.highEndWindows?'Windows':'';  items.push('High-End Laptop ($1,200+)'+(os?' - '+os:'')) }
    if (itReq.keyboardMouse)  { const os = itReq.keyboardMac&&itReq.keyboardWindows?'Mac & Windows':itReq.keyboardMac?'Mac':itReq.keyboardWindows?'Windows':''; items.push('Keyboard/Mouse'+(os?' - '+os:'')) }
    if (itReq.webcam) items.push('Webcam')
    if (itReq.cable) items.push('Cable'+(itReq.cableType?' - '+itReq.cableType:''))
    if (itReq.charger) items.push('Charger'+(itReq.chargerType?' - '+itReq.chargerType:''))
    if (itReq.dockingStation) { const os = itReq.dockingMac&&itReq.dockingWindows?'Mac & Windows':itReq.dockingMac?'Mac':itReq.dockingWindows?'Windows':''; items.push('Docking Station'+(os?' - '+os:'')) }
    if (itReq.externalStorage) { if (itReq.usbFlash) items.push('USB Flash Drive'); if (itReq.usbHardDrive) items.push('USB External Hard Drive'); if (!itReq.usbFlash&&!itReq.usbHardDrive) items.push('External Storage') }
    if (itReq.monitor) { const sz = itReq.monitorStandard&&itReq.monitorLarge?'Standard & Large':itReq.monitorStandard?'Standard':itReq.monitorLarge?'Large':''; items.push('Monitor'+(sz?' - '+sz:'')) }
    if (itReq.software) items.push('Software'+(itReq.softwareType?' - '+itReq.softwareType:''))
    if (itReq.other) items.push('Other'+(itReq.otherType?' - '+itReq.otherType:''))
    return items
  }

  function buildFacItems() {
    const items = []
    if (facReq.mainEntrance) items.push('Main entrance access')
    if (facReq.deptWing) items.push(`${newEmp.dept || 'Department'} wing access`)
    if (facReq.parking) items.push('Parking garage access')
    if (facReq.breakRoom) items.push('Break room access')
    if (facReq.serverRoom) items.push('Server room access')
    if (facReq.execFloor) items.push('Executive floor access')
    if (facReq.other && facReq.otherNote) items.push(facReq.otherNote)
    return items
  }

  function handleLaunchOnboarding() {
    if (!newEmp.firstName || !newEmp.email) { alert('Please fill in at least a name and email.'); return }
    setPacketSent(true)
    setTimeout(() => {
      setPacketSent(false)
      setShowNewEmployee(false)
      setStep(1)
      setNewEmp({ firstName:'', lastName:'', email:'', phone:'', dept:'Operations', position:'', startDate:'', type:'Full Time' })
      setChecklist({ offer:false, i9:false, background:false, handbook:true, policies:true, training:true, portal:true })
      setItReq({ standardLaptop:false, standardMac:false, standardWindows:false, highEndLaptop:false, highEndMac:false, highEndWindows:false, keyboardMouse:true, keyboardMac:false, keyboardWindows:true, webcam:false, cable:false, cableType:'', charger:false, chargerType:'', dockingStation:false, dockingMac:false, dockingWindows:false, externalStorage:false, usbFlash:false, usbHardDrive:false, monitor:true, monitorStandard:true, monitorLarge:false, software:false, softwareType:'', other:false, otherType:'', fundingSource:'HR-ONBOARD-2025', approvedBy:'Tiffany Gallagher', assignTo:'John Gallagher' })
      setFacReq({ mainEntrance:true, deptWing:true, parking:false, breakRoom:true, serverRoom:false, execFloor:false, other:false, otherNote:'', assignTo:'Facilities Team' })
    }, 5000)
  }

  function closeModal() {
    setShowNewEmployee(false)
    setStep(1)
    setPacketSent(false)
  }

  const inputStyle = { width:'100%', padding:'9px 13px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', color:'#2B2B2B', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:10, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }

  const checkRow = (setter, state, field, label, children) => (
    <div style={{marginBottom:6}}>
      <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:12,color:'#2B2B2B',fontWeight:500}}>
        <input type="checkbox" checked={state[field]} onChange={()=>tog(setter,field)} style={{accentColor:accent,width:14,height:14,flexShrink:0}}/>
        {label}
      </label>
      {state[field] && children && <div style={{marginLeft:26,marginTop:4}}>{children}</div>}
    </div>
  )

  const subCheck = (setter, state, field, label) => (
    <label key={field} style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer',fontSize:11,color:'#6B7D6B',marginBottom:3}}>
      <input type="checkbox" checked={state[field]} onChange={()=>tog(setter,field)} style={{accentColor:accent,width:12,height:12}}/>
      {label}
    </label>
  )

  const specifyInput = (setter, state, field, placeholder) => (
    <input value={state[field]} onChange={e=>setter(s=>({...s,[field]:e.target.value}))} placeholder={placeholder}
      style={{...inputStyle, fontSize:11, padding:'5px 8px', marginTop:4}}/>
  )

  const ticketPreviewStyle = { background:'#F7F2EB', border:'1px solid #EDE6DA', borderRadius:8, padding:'12px 14px', marginBottom:10 }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Employees</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>{employees.filter(e=>e.status!=='onboarding').length} active &middot; {onboarding.length} onboarding</p>
        </div>
        <button onClick={() => setShowNewEmployee(true)}
          style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
          + New Employee
        </button>
      </div>

      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {[['active','Active Employees'],['onboarding','Onboarding Roster']].map(([key,label],i)=>(
          <button key={key} onClick={()=>setActiveView(key)}
            style={{padding:'8px 20px',border:'none',borderRight:i===0?'1px solid #EDE6DA':'none',background:activeView===key?accent:'#fff',color:activeView===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
            {label}
            {key==='onboarding' && <span style={{marginLeft:6,padding:'1px 6px',borderRadius:8,background:activeView==='onboarding'?'rgba(255,255,255,0.3)':'rgba(74,106,138,0.15)',color:activeView==='onboarding'?'#fff':'#4A6B8A',fontSize:10,fontWeight:700}}>{onboarding.length}</span>}
          </button>
        ))}
      </div>

      {activeView === 'active' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search employees..." style={{padding:'7px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',width:200}}/>
            <select value={filterDept} onChange={e=>setFilterDept(e.target.value)} style={{padding:'7px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
              {depts.map(d=><option key={d}>{d}</option>)}
            </select>
            <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{padding:'7px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
              {['All','active','warning','onboarding'].map(s=><option key={s} value={s}>{s==='All'?'All Statuses':statusLabel(s)}</option>)}
            </select>
            <div style={{marginLeft:'auto',fontSize:11,color:'#8A9E8A'}}>{filtered.length} employees</div>
          </div>
          <div style={{maxHeight:520,overflowY:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead style={{position:'sticky',top:0,zIndex:1}}>
                <tr style={{background:'#F7F2EB'}}>
                  {['Employee','Department','Position','Status','Attendance','Score','Hire Date',''].map(h=>(
                    <th key={h} style={{textAlign:'left',padding:'8px 16px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(e=>(
                  <tr key={e.id} onClick={()=>navigate(`/admin/employees/${e.id}`)}
                    style={{borderBottom:'1px solid #EDE6DA',cursor:'pointer'}}
                    onMouseEnter={ev=>ev.currentTarget.style.background=accentBg}
                    onMouseLeave={ev=>ev.currentTarget.style.background='transparent'}>
                    <td style={{padding:'12px 16px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <div style={{width:30,height:30,borderRadius:'50%',background:accentLight,color:accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,flexShrink:0}}>{e.init}</div>
                        <span style={{fontWeight:600,color:'#2B2B2B'}}>{e.name}</span>
                      </div>
                    </td>
                    <td style={{padding:'12px 16px',color:'#4A4A4A'}}>{e.dept}</td>
                    <td style={{padding:'12px 16px',color:'#6B7D6B',fontSize:11}}>{e.position}</td>
                    <td style={{padding:'12px 16px'}}>
                      <span style={{display:'inline-flex',alignItems:'center',gap:4}}>
                        <span style={{width:7,height:7,borderRadius:'50%',background:statusColor(e.status),display:'inline-block'}}/>
                        <span style={{fontSize:11,color:statusColor(e.status),fontWeight:500}}>{statusLabel(e.status)}</span>
                      </span>
                    </td>
                    <td style={{padding:'12px 16px'}}>
                      {e.attendance ? (
                        <div style={{display:'flex',alignItems:'center',gap:6}}>
                          <div style={{width:40,height:4,background:'#EDE6DA',borderRadius:2,overflow:'hidden'}}>
                            <div style={{height:'100%',width:e.attendance+'%',background:e.attendance>=95?'#4A7C59':e.attendance>=85?accent:'#A0392B',borderRadius:2}}/>
                          </div>
                          <span style={{fontSize:11,color:'#4A4A4A'}}>{e.attendance}%</span>
                        </div>
                      ) : <span style={{color:'#8A9E8A',fontSize:11}}>--</span>}
                    </td>
                    <td style={{padding:'12px 16px'}}>
                      {e.score ? <span style={{fontFamily:'Georgia,serif',fontSize:13,color:e.score>=4?'#4A7C59':e.score>=3?accent:'#A0392B',fontWeight:600}}>{e.score}</span>
                      : <span style={{color:'#8A9E8A',fontSize:11}}>--</span>}
                    </td>
                    <td style={{padding:'12px 16px',color:'#8A9E8A',fontSize:11}}>{e.hire}</td>
                    <td style={{padding:'12px 16px'}}><span style={{fontSize:11,color:accent,fontWeight:600}}>View &rarr;</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeView === 'onboarding' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Onboarding Roster</div>
            <span style={{fontSize:11,color:'#6B7D6B'}}>{onboarding.length} candidates in progress</span>
          </div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead>
              <tr style={{background:'#F7F2EB'}}>
                {['Candidate','Department','Offer Letter','I-9','Handbook','Training','Progress','Start Date'].map(h=>(
                  <th key={h} style={{textAlign:'left',padding:'8px 16px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {onboarding.map(o=>(
                <tr key={o.id} style={{borderBottom:'1px solid #EDE6DA'}}>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <div style={{width:30,height:30,borderRadius:'50%',background:'rgba(74,106,138,0.12)',color:'#4A6B8A',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,flexShrink:0}}>{o.init}</div>
                      <div>
                        <div style={{fontWeight:600,color:'#2B2B2B'}}>{o.name}</div>
                        <div style={{fontSize:10,color:'#8A9E8A'}}>{o.position}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{padding:'12px 16px',color:'#4A4A4A'}}>{o.dept}</td>
                  {['offer','i9','handbook','training'].map(s=>(
                    <td key={s} style={{padding:'12px 16px',textAlign:'center'}}>
                      {o.steps > ['offer','i9','handbook','training'].indexOf(s)
                        ? <span style={{color:'#4A7C59',fontSize:16}}>✓</span>
                        : <span style={{color:'#EDE6DA',fontSize:16}}>○</span>}
                    </td>
                  ))}
                  <td style={{padding:'12px 16px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <div style={{width:60,height:6,background:'#EDE6DA',borderRadius:3,overflow:'hidden'}}>
                        <div style={{height:'100%',width:o.progress+'%',background:o.progress===100?'#4A7C59':accent,borderRadius:3}}/>
                      </div>
                      <span style={{fontSize:11,fontWeight:600,color:o.progress===100?'#4A7C59':accent}}>{o.progress}%</span>
                    </div>
                  </td>
                  <td style={{padding:'12px 16px',color:'#4A4A4A',fontSize:11}}>{o.startDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* New Employee Modal */}
      {showNewEmployee && (
        <div style={{position:'fixed',inset:0,background:'rgba(43,43,43,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
          <div style={{background:'#fff',borderRadius:14,width:'100%',maxWidth:680,boxShadow:'0 20px 60px rgba(43,43,43,0.25)',overflow:'hidden',maxHeight:'92vh',display:'flex',flexDirection:'column'}}>

            {/* Modal header */}
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between',background:'#2B2B2B',flexShrink:0}}>
              <div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',fontWeight:600,color:'#fff'}}>New Employee Setup</div>
                <div style={{fontSize:11,color:'rgba(217,195,163,0.6)',marginTop:2}}>
                  {step===1?'Step 1 of 4 — Basic Information':step===2?'Step 2 of 4 — Onboarding Checklist':step===3?'Step 3 of 4 — IT & Facilities Requests':'Step 4 of 4 — Review & Launch'}
                </div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <div style={{display:'flex',gap:6}}>
                  {[1,2,3,4].map(s=>(
                    <div key={s} style={{width:24,height:24,borderRadius:'50%',background:s<=step?accent:'rgba(255,255,255,0.1)',color:s<=step?'#fff':'rgba(255,255,255,0.3)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700}}>{s}</div>
                  ))}
                </div>
                <button onClick={closeModal} style={{background:'none',border:'none',fontSize:20,color:'rgba(255,255,255,0.4)',cursor:'pointer',lineHeight:1}}>&times;</button>
              </div>
            </div>

            {/* Scrollable content */}
            <div style={{overflowY:'auto',flex:1}}>
              {packetSent ? (
                <div style={{padding:'3rem',textAlign:'center'}}>
                  <div style={{width:64,height:64,borderRadius:'50%',background:'rgba(74,124,89,0.1)',border:'2px solid #4A7C59',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px',fontSize:28}}>✓</div>
                  <div style={{fontFamily:'Georgia,serif',fontSize:'1.3rem',color:'#2B2B2B',marginBottom:12}}>Onboarding Launched!</div>
                  <div style={{fontSize:13,color:'#6B7D6B',lineHeight:2,marginBottom:16}}>
                    Profile created for <strong>{newEmp.firstName} {newEmp.lastName}</strong>.<br/>
                    Welcome email sent to <strong>{newEmp.email}</strong>.<br/>
                    Onboarding checklist assigned.
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:8,maxWidth:340,margin:'0 auto'}}>
                    <div style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'rgba(74,107,138,0.06)',border:'1px solid rgba(74,107,138,0.2)',borderRadius:8}}>
                      <span style={{fontSize:16}}>&#128187;</span>
                      <div style={{textAlign:'left'}}>
                        <div style={{fontSize:11,fontWeight:600,color:'#4A6B8A'}}>IT Ticket Auto-Generated</div>
                        <div style={{fontSize:10,color:'#8A9E8A'}}>Assigned to {itReq.assignTo} &middot; High Priority</div>
                      </div>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8}}>
                      <span style={{fontSize:16}}>&#127970;</span>
                      <div style={{textAlign:'left'}}>
                        <div style={{fontSize:11,fontWeight:600,color:'#4A7C59'}}>Facilities Ticket Auto-Generated</div>
                        <div style={{fontSize:10,color:'#8A9E8A'}}>Assigned to {facReq.assignTo} &middot; High Priority</div>
                      </div>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:accentBg,border:`1px solid ${accent}33`,borderRadius:8}}>
                      <span style={{fontSize:16}}>&#128140;</span>
                      <div style={{textAlign:'left'}}>
                        <div style={{fontSize:11,fontWeight:600,color:accent}}>Welcome Memo Sent</div>
                        <div style={{fontSize:10,color:'#8A9E8A'}}>Delivered to {newEmp.email}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{padding:'24px'}}>

                  {/* Step 1 - Basic Info */}
                  {step === 1 && (
                    <div style={{display:'flex',flexDirection:'column',gap:16}}>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                        {[['First Name','firstName','text'],['Last Name','lastName','text'],['Email Address','email','email'],['Phone Number','phone','tel']].map(([label,key,type])=>(
                          <div key={key}>
                            <label style={labelStyle}>{label}</label>
                            <input type={type} value={newEmp[key]} onChange={e=>setNewEmp(n=>({...n,[key]:e.target.value}))} style={inputStyle}/>
                          </div>
                        ))}
                        <div>
                          <label style={labelStyle}>Department</label>
                          <select value={newEmp.dept} onChange={e=>setNewEmp(n=>({...n,dept:e.target.value}))} style={inputStyle}>
                            {['Operations','Administrative','Field Staff','Customer Service'].map(d=><option key={d}>{d}</option>)}
                          </select>
                        </div>
                        <div>
                          <label style={labelStyle}>Employment Type</label>
                          <select value={newEmp.type} onChange={e=>setNewEmp(n=>({...n,type:e.target.value}))} style={inputStyle}>
                            {['Full Time','Part Time','Contract','Seasonal'].map(t=><option key={t}>{t}</option>)}
                          </select>
                        </div>
                        <div>
                          <label style={labelStyle}>Position / Title</label>
                          <input value={newEmp.position} onChange={e=>setNewEmp(n=>({...n,position:e.target.value}))} style={inputStyle}/>
                        </div>
                        <div>
                          <label style={labelStyle}>Start Date</label>
                          <input type="date" value={newEmp.startDate} onChange={e=>setNewEmp(n=>({...n,startDate:e.target.value}))} style={inputStyle}/>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 2 - Onboarding Checklist */}
                  {step === 2 && (
                    <div style={{display:'flex',flexDirection:'column',gap:10}}>
                      <p style={{fontSize:13,color:'#6B7D6B',marginBottom:8}}>Select items for <strong>{newEmp.firstName || 'this employee'}</strong>'s onboarding packet.</p>
                      {[
                        { key:'offer',      label:'Offer Letter',       sub:'Send offer letter for digital signature',         required:false },
                        { key:'i9',         label:'I-9 Verification',   sub:'Employment eligibility verification form',        required:false },
                        { key:'background', label:'Background Check',   sub:'Initiate background screening process',           required:false },
                        { key:'handbook',   label:'Employee Handbook',  sub:'Assign handbook for review and e-signature',      required:true  },
                        { key:'policies',   label:'Company Policies',   sub:'Assign all active policies for acknowledgment',   required:true  },
                        { key:'training',   label:'Training Modules',   sub:'Assign required training and compliance modules', required:true  },
                        { key:'portal',     label:'Portal Login',       sub:'Create account and send login credentials',       required:true  },
                      ].map(item=>(
                        <div key={item.key} onClick={()=>!item.required&&setChecklist(c=>({...c,[item.key]:!c[item.key]}))}
                          style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',border:`1px solid ${checklist[item.key]?accent:'#EDE6DA'}`,borderRadius:8,background:checklist[item.key]?accentBg:'#fff',cursor:item.required?'default':'pointer',transition:'all 0.15s'}}>
                          <div style={{width:20,height:20,borderRadius:4,border:`1.5px solid ${checklist[item.key]?accent:'#D9C3A3'}`,background:checklist[item.key]?accent:'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                            {checklist[item.key] && <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2 2 4-4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/></svg>}
                          </div>
                          <div style={{flex:1}}>
                            <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>{item.label}</div>
                            <div style={{fontSize:11,color:'#6B7D6B'}}>{item.sub}</div>
                          </div>
                          {item.required && <span style={{fontSize:9,padding:'2px 7px',borderRadius:8,background:'rgba(74,124,89,0.1)',color:'#4A7C59',fontWeight:600}}>Required</span>}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Step 3 - IT & Facilities */}
                  {step === 3 && (
                    <div style={{display:'flex',flexDirection:'column',gap:16}}>
                      <p style={{fontSize:13,color:'#6B7D6B'}}>Configure IT equipment and building access for <strong>{newEmp.firstName || 'this employee'}</strong>. These will auto-generate tickets in Collective Services.</p>

                      {/* IT Section */}
                      <div style={{border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
                        <div style={{padding:'12px 16px',background:'rgba(74,107,138,0.06)',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:8}}>
                          <span style={{fontSize:14}}>&#128187;</span>
                          <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B'}}>IT Equipment Request</div>
                          <span style={{fontSize:9,padding:'2px 6px',borderRadius:8,background:'rgba(217,195,163,0.15)',color:'#4A6B8A',fontWeight:600,marginLeft:'auto'}}>AUTO-TICKET &rarr; IT QUEUE</span>
                        </div>
                        <div style={{padding:'16px'}}>
                          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 24px',marginBottom:14}}>
                            <div>
                              <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Computer Type</div>
                              {checkRow(setItReq, itReq, 'standardLaptop', 'Standard Laptop ($499-$899)',
                                <>{subCheck(setItReq,itReq,'standardMac','Mac')}{subCheck(setItReq,itReq,'standardWindows','Windows')}</>
                              )}
                              {checkRow(setItReq, itReq, 'highEndLaptop', 'High-End Laptop ($1,200+)',
                                <>{subCheck(setItReq,itReq,'highEndMac','Mac')}{subCheck(setItReq,itReq,'highEndWindows','Windows')}</>
                              )}
                            </div>
                            <div>
                              <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Accessory Type</div>
                              {checkRow(setItReq, itReq, 'keyboardMouse', 'Keyboard/Mouse',
                                <>{subCheck(setItReq,itReq,'keyboardMac','Mac')}{subCheck(setItReq,itReq,'keyboardWindows','Windows')}</>
                              )}
                              {checkRow(setItReq, itReq, 'webcam', 'Webcam')}
                              {checkRow(setItReq, itReq, 'cable', 'Cable (Specify Type)', specifyInput(setItReq,itReq,'cableType','e.g. HDMI, USB-C...'))}
                              {checkRow(setItReq, itReq, 'charger', 'Charger (Specify Type)', specifyInput(setItReq,itReq,'chargerType','e.g. MacBook 65W...'))}
                              {checkRow(setItReq, itReq, 'dockingStation', 'Docking Station',
                                <>{subCheck(setItReq,itReq,'dockingMac','Mac')}{subCheck(setItReq,itReq,'dockingWindows','Windows')}</>
                              )}
                              {checkRow(setItReq, itReq, 'externalStorage', 'External Storage',
                                <>{subCheck(setItReq,itReq,'usbFlash','USB Flash Drive')}{subCheck(setItReq,itReq,'usbHardDrive','USB External Hard Drive')}</>
                              )}
                              {checkRow(setItReq, itReq, 'monitor', 'Monitor',
                                <>{subCheck(setItReq,itReq,'monitorStandard','Standard')}{subCheck(setItReq,itReq,'monitorLarge','Large')}</>
                              )}
                              {checkRow(setItReq, itReq, 'software', 'Software (Specify Type)', specifyInput(setItReq,itReq,'softwareType','e.g. Adobe, Slack...'))}
                              {checkRow(setItReq, itReq, 'other', 'Other (Specify Type)', specifyInput(setItReq,itReq,'otherType','Please describe...'))}
                            </div>
                          </div>
                          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10,paddingTop:12,borderTop:'1px solid #EDE6DA'}}>
                            <div>
                              <label style={labelStyle}>Funding Source *</label>
                              <input value={itReq.fundingSource} onChange={e=>setItReq(s=>({...s,fundingSource:e.target.value}))} style={{...inputStyle,fontSize:11,padding:'6px 10px'}}/>
                            </div>
                            <div>
                              <label style={labelStyle}>Approved By *</label>
                              <input value={itReq.approvedBy} onChange={e=>setItReq(s=>({...s,approvedBy:e.target.value}))} style={{...inputStyle,fontSize:11,padding:'6px 10px'}}/>
                            </div>
                            <div>
                              <label style={labelStyle}>Assign To</label>
                              <select value={itReq.assignTo} onChange={e=>setItReq(s=>({...s,assignTo:e.target.value}))} style={{...inputStyle,fontSize:11,padding:'6px 10px'}}>
                                {['John Gallagher','IT Support','Unassigned'].map(o=><option key={o}>{o}</option>)}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Facilities Section */}
                      <div style={{border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
                        <div style={{padding:'12px 16px',background:'rgba(74,124,89,0.04)',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:8}}>
                          <span style={{fontSize:14}}>&#127970;</span>
                          <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B'}}>Building Access Request</div>
                          <span style={{fontSize:9,padding:'2px 6px',borderRadius:8,background:'rgba(74,124,89,0.1)',color:'#4A7C59',fontWeight:600,marginLeft:'auto'}}>AUTO-TICKET &rarr; FACILITIES QUEUE</span>
                        </div>
                        <div style={{padding:'16px'}}>
                          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 24px',marginBottom:14}}>
                            <div>
                              <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Access Areas</div>
                              {[
                                ['mainEntrance','Main entrance'],
                                ['deptWing',`${newEmp.dept || 'Department'} wing`],
                                ['parking','Parking garage'],
                                ['breakRoom','Break room'],
                                ['serverRoom','Server room'],
                                ['execFloor','Executive floor'],
                              ].map(([field,label])=>checkRow(setFacReq, facReq, field, label))}
                              {checkRow(setFacReq, facReq, 'other', 'Other (specify)',
                                specifyInput(setFacReq, facReq, 'otherNote', 'Describe access needed...')
                              )}
                            </div>
                            <div>
                              <div style={{fontSize:11,fontWeight:700,color:'#2B2B2B',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.05em'}}>Assign To</div>
                              <select value={facReq.assignTo} onChange={e=>setFacReq(s=>({...s,assignTo:e.target.value}))} style={{...inputStyle,fontSize:11,padding:'6px 10px'}}>
                                {['Facilities Team','Building Manager','Unassigned'].map(o=><option key={o}>{o}</option>)}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 4 - Review & Launch */}
                  {step === 4 && (
                    <div style={{display:'flex',flexDirection:'column',gap:12}}>
                      <p style={{fontSize:13,color:'#6B7D6B'}}>Review everything below. Clicking <strong>Launch Onboarding</strong> will create the employee profile and auto-generate all tickets and assignments.</p>

                      {/* Employee summary */}
                      <div style={ticketPreviewStyle}>
                        <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:10}}>Employee</div>
                        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
                          {[['Name',`${newEmp.firstName} ${newEmp.lastName}`],['Email',newEmp.email],['Department',newEmp.dept],['Position',newEmp.position||'--'],['Type',newEmp.type],['Start Date',newEmp.startDate||'--']].map(([l,v])=>(
                            <div key={l}><div style={{fontSize:9,color:'#8A9E8A',fontWeight:600,textTransform:'uppercase'}}>{l}</div><div style={{fontSize:12,color:'#2B2B2B',fontWeight:500}}>{v}</div></div>
                          ))}
                        </div>
                      </div>

                      {/* IT ticket preview */}
                      <div style={{...ticketPreviewStyle,background:'rgba(74,107,138,0.04)',border:'1px solid rgba(74,107,138,0.2)'}}>
                        <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:8}}>
                          <span style={{fontSize:12}}>&#128187;</span>
                          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#4A6B8A',fontWeight:600}}>IT Ticket (auto-generated)</div>
                        </div>
                        <div style={{fontSize:12,fontWeight:600,color:'#2B2B2B',marginBottom:6}}>New hire setup - {newEmp.firstName} {newEmp.lastName}</div>
                        {buildITItems().length > 0
                          ? buildITItems().map((item,i)=>(
                            <div key={i} style={{display:'flex',alignItems:'center',gap:6,fontSize:11,color:'#4A4A4A',marginBottom:2}}>
                              <div style={{width:4,height:4,borderRadius:'50%',background:'#4A6B8A',flexShrink:0}}></div>{item}
                            </div>
                          ))
                          : <div style={{fontSize:11,color:'#8A9E8A',fontStyle:'italic'}}>No equipment selected</div>
                        }
                        <div style={{marginTop:8,fontSize:11,color:'#4A6B8A'}}>Funding: <strong>{itReq.fundingSource}</strong> &middot; Approved: <strong>{itReq.approvedBy}</strong> &middot; Assigned: <strong>{itReq.assignTo}</strong></div>
                      </div>

                      {/* Facilities ticket preview */}
                      <div style={{...ticketPreviewStyle,background:'rgba(74,124,89,0.04)',border:'1px solid rgba(74,124,89,0.2)'}}>
                        <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:8}}>
                          <span style={{fontSize:12}}>&#127970;</span>
                          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#4A7C59',fontWeight:600}}>Facilities Ticket (auto-generated)</div>
                        </div>
                        <div style={{fontSize:12,fontWeight:600,color:'#2B2B2B',marginBottom:6}}>Building access - {newEmp.firstName} {newEmp.lastName}</div>
                        {buildFacItems().length > 0
                          ? buildFacItems().map((item,i)=>(
                            <div key={i} style={{display:'flex',alignItems:'center',gap:6,fontSize:11,color:'#4A4A4A',marginBottom:2}}>
                              <div style={{width:4,height:4,borderRadius:'50%',background:'#4A7C59',flexShrink:0}}></div>{item}
                            </div>
                          ))
                          : <div style={{fontSize:11,color:'#8A9E8A',fontStyle:'italic'}}>No access areas selected</div>
                        }
                        <div style={{marginTop:8,fontSize:11,color:'#4A7C59'}}>Assigned: <strong>{facReq.assignTo}</strong></div>
                      </div>

                      {/* Onboarding packet */}
                      <div style={ticketPreviewStyle}>
                        <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Onboarding Packet</div>
                        <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                          {Object.entries(checklist).filter(([,v])=>v).map(([k])=>{
                            const labels = {offer:'Offer Letter',i9:'I-9',background:'Background Check',handbook:'Employee Handbook',policies:'Company Policies',training:'Training Modules',portal:'Portal Login'}
                            return <span key={k} style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:'rgba(74,124,89,0.1)',color:'#4A7C59',fontWeight:500}}>✓ {labels[k]}</span>
                          })}
                        </div>
                      </div>

                      <div style={{padding:'12px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8,fontSize:12,color:'#4A7C59'}}>
                        &#128140; Welcome email will be sent to <strong>{newEmp.email}</strong> with login credentials and onboarding checklist.
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer navigation */}
            {!packetSent && (
              <div style={{display:'flex',justifyContent:'space-between',padding:'16px 24px',borderTop:'1px solid #EDE6DA',background:'#fff',flexShrink:0}}>
                <button onClick={()=>step>1?setStep(s=>s-1):closeModal()}
                  style={{padding:'9px 20px',background:'#fff',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  {step === 1 ? 'Cancel' : '← Back'}
                </button>
                {step < 4
                  ? <button onClick={()=>setStep(s=>s+1)}
                      style={{padding:'9px 24px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      Continue &rarr;
                    </button>
                  : <button onClick={handleLaunchOnboarding}
                      style={{padding:'9px 24px',background:'#4A7C59',border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      &#128640; Launch Onboarding
                    </button>
                }
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
